import {
  gateway, gatewayShortJson,
} from '../../api';
import { getUriParams } from '../../../helpers/utils/utils';

const CORE = process.env.REACT_APP_CORE;

export function findAllFases(permiteReceberProcesso) {
  let uri = getUriParams({ permiteReceberProcesso });
  if (uri !== '') {
    uri = `?${uri}`;
  }

  return gatewayShortJson.get(`${CORE}/fases?${uri}`);
}

export function findAllFasessWhatsapp(permiteReceberProcesso) {
  let uri = getUriParams({ permiteReceberProcesso });
  if (uri !== '') {
    uri = `?${uri}`;
  }

  return gatewayShortJson.get(`${CORE}/fases/whatsapp?${uri}`);
}

export function getFaseById(idFase) {
  return gateway.get(`${CORE}/fases/${idFase}`);
}

export function updateFase(idFase, payload) {
  return gateway.put(`${CORE}/fases/${idFase}`, payload);
}

export function getUsuariosAtivosFase(idFase) {
  return gateway.get(`${CORE}/fases/${idFase}/usuarios`);
}

export function buscarFasesParaSelecaoEnvioProcessoService(permiteCobrancaPresencial, idFaseAtual) {
  return gatewayShortJson.get(`${CORE}/fases/processos/${permiteCobrancaPresencial}/${idFaseAtual}`);
}

export function findFasesEnviarProcessos(permiteCobrancaPresencial, processosSelecionados) {
  return gateway.post(`${CORE}/fases/processos/fases-enviar-processos/${permiteCobrancaPresencial}`, processosSelecionados);
}


// Ids tipos fases
export function buscarIdFaseAcordoSeguro() {
  return gateway.get(`${CORE}/fases/tipo-fase/acordo-seguro`);
}

export function buscarIdFaseBaixa() {
  return gateway.get(`${CORE}/fases/tipo-fase/baixa`);
}
